if (!customElements.get('ly-image-previewer')) {
    customElements.define('ly-image-previewer', class extends HTMLElement {
        connectedCallback() {
            this.img = this.querySelector('img')
            if (!this.img) return

            this.img.addEventListener('click', this.enablePreview)
        }

        disconnectedCallback() {
            this.disablePreview()

            this.img?.removeEventListener('click', this.enablePreview)
        }

        enablePreview = () => {
            const originalUrl = this.img.src.split('?')[0]

            this.rotation = 0
            this.scale = 1
            this.offsetX = 0
            this.offsetY = 0
            this.dragging = false

            document.body.classList.add('ly-image-previewer-running')

            this.previewWrapper = document.createElement('div')
            this.previewWrapper.className = 'ly-image-previewer-wrapper'

            this.previewWrapper.innerHTML = `
              <button class="ly-image-previewer-close-btn ly-image-previewer-btn-item">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.8571 0.858803L0.857673 10.8572M0.857117 0.857178L10.8566 10.8556" stroke="currentColor" stroke-width="1.71429" stroke-linecap="round"/>
                </svg>
              </button>
              <div class="ly-image-previewer-loading"></div>
              <div class="ly-image-previewer-toolbar">
                <button class="rotate-left ly-image-previewer-btn-item">
                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M121.6 502.4c32 0 57.6 25.6 57.6 60.8 0 188.8 147.2 342.4 329.6 342.4 182.4 0 329.6-153.6 329.6-342.4 0-188.8-147.2-342.4-329.6-342.4V320L278.4 160 512 0v99.2c246.4 0 448 208 448 460.8S758.4 1024 512 1024 64 816 64 563.2c0-35.2 25.6-60.8 57.6-60.8"></path>
                    </svg>
                </button>
                <button class="rotate-right ly-image-previewer-btn-item">
                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M444.6 71C201.4 71 4.2 268.8 4.2 512.7c0 243.9 197.2 441.7 440.4 441.7 102.3 0 196.4-35 271.1-93.7l-75.8-81C585.2 820.1 517.6 844 444.6 844c-182.5 0-330.3-148.3-330.3-331.3s147.8-331.3 330.3-331.3c178.7 0 324.1 142.4 329.9 320.2H620.6l198.1 220.9 198.2-220.9H884.6C878.7 262.9 684 71.1 444.6 71z m0 0.1"></path>
                    </svg>
                </button>
                <button class="zoom-in ly-image-previewer-btn-item">
                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M889.16 584.94H134.84c-39.32 0-71.2-32.65-71.2-72.94s31.88-72.94 71.2-72.94h754.31c39.32 0 71.2 32.65 71.2 72.94s-31.87 72.94-71.19 72.94z"></path>
                        <path d="M512 960.35c-39.32 0-71.2-32.65-71.2-72.94V136.58c0-40.28 31.88-72.94 71.2-72.94s71.2 32.65 71.2 72.94v750.84c0 40.28-31.88 72.93-71.2 72.93z"></path>
                    </svg>
                </button>
                <button class="zoom-out ly-image-previewer-btn-item">
                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
                        <path d="M887.44 583.9H136.56c-39.71 0-71.9-32.19-71.9-71.9s32.19-71.9 71.9-71.9h750.87c39.71 0 71.9 32.19 71.9 71.9s-32.19 71.9-71.89 71.9z"></path>
                    </svg>
                </button>
              </div>
              <img class="ly-image-previewer-img" src="${originalUrl}" draggable="false" />
            `

            // 再插入 DOM
            document.body.appendChild(this.previewWrapper)

            this.loadingEl = this.previewWrapper.querySelector('.ly-image-previewer-loading')
            this.previewImg = this.previewWrapper.querySelector('.ly-image-previewer-img')

            // 先绑定
            this.previewImg.onload = this.handleImageLoaded

            // 关键：处理缓存已完成情况
            if (this.previewImg.complete) {
                this.handleImageLoaded()
            }

            // 关闭按钮
            this.previewWrapper.querySelector('.ly-image-previewer-close-btn')
                .addEventListener('click', this.disablePreview)

            // 点击蒙层关闭（关键）
            this.previewWrapper.addEventListener('click', (e) => {
                if (e.target === this.previewWrapper) {
                    this.disablePreview()
                }
            })

            // 工具栏
            this.previewWrapper.querySelector('.ly-image-previewer-toolbar>.rotate-left').addEventListener('click', this.rotateLeft)
            this.previewWrapper.querySelector('.ly-image-previewer-toolbar>.rotate-right').addEventListener('click', this.rotateRight)
            this.previewWrapper.querySelector('.ly-image-previewer-toolbar>.zoom-in').addEventListener('click', this.zoomIn)
            this.previewWrapper.querySelector('.ly-image-previewer-toolbar>.zoom-out').addEventListener('click', this.zoomOut)

            this.previewImg.addEventListener('pointerdown', this.onPointerDown)
        }

        disablePreview = () => {
            document.body.classList.remove('overflow-hidden')

            if (this.previewImg) {
                this.previewImg.removeEventListener('mousedown', this.onDragStart)
                this.previewImg.removeEventListener('touchstart', this.onTouchStart)
            }

            window.removeEventListener('mousemove', this.onDragging)
            window.removeEventListener('mouseup', this.onDragEnd)
            window.removeEventListener('touchmove', this.onTouchMove)
            window.removeEventListener('touchend', this.onTouchEnd)

            if (this.previewWrapper) {
                this.previewWrapper.remove()
                this.previewWrapper = null
                this.previewImg = null
            }
        }

        handleImageLoaded = () => {
            if (!this.loadingEl || !this.previewImg) return

            this.loadingEl.remove()
            this.previewImg.style.display = 'block'
        }

        rotateLeft = () => {
            this.rotation -= 90
            this.updateTransform()
        }

        rotateRight = () => {
            this.rotation += 90
            this.updateTransform()
        }

        zoomIn = () => {
            this.scale = Math.min(this.scale + 0.2, 4)
            this.updateTransform()
        }

        zoomOut = () => {
            this.scale = Math.max(this.scale - 0.2, 0.4)
            this.updateTransform()
        }

        updateTransform = () => {
            if (this.previewImg) {
                this.previewImg.style.transform =
                    `translate(${this.offsetX}px, ${this.offsetY}px) scale(${this.scale}) rotate(${this.rotation}deg)`
            }
        }

        onPointerDown = (e) => {
            // 只处理主指针（防止多点干扰）
            if (e.button !== 0 && e.pointerType === 'mouse') return

            this.dragging = true
            this.startX = e.clientX
            this.startY = e.clientY

            this.previewImg.style.transition = 'none'

            // 🔥 关键：捕获指针（拖出元素也能继续拖）
            this.previewImg.setPointerCapture(e.pointerId)

            this.previewImg.addEventListener('pointermove', this.onPointerMove)
            this.previewImg.addEventListener('pointerup', this.onPointerUp)
            this.previewImg.addEventListener('pointercancel', this.onPointerUp)
        }

        onPointerMove = (e) => {
            if (!this.dragging) return

            const dx = e.clientX - this.startX
            const dy = e.clientY - this.startY

            this.offsetX += dx
            this.offsetY += dy

            this.startX = e.clientX
            this.startY = e.clientY

            this.updateTransform()
        }

        onPointerUp = (e) => {
            this.dragging = false

            this.previewImg.style.transition = 'transform 0.3s ease'

            try {
                this.previewImg.releasePointerCapture(e.pointerId)
            } catch (e) { }

            this.previewImg.removeEventListener('pointermove', this.onPointerMove)
            this.previewImg.removeEventListener('pointerup', this.onPointerUp)
            this.previewImg.removeEventListener('pointercancel', this.onPointerUp)
        }
    })
}